import ProfileEdit from "@/views/Profile/ProfileEdit.vue";
const routes = [
    {
        path: "/profile/edit",
        name: "ProfileEdit",
        component: ProfileEdit,
    },
];
export default routes;
